import { secondAxios } from "../../../../../../../api/axios";

export const createMrq = async ({ id, createdMrq }) => {
  const { data } = await secondAxios.put("/mrq/" + id, createdMrq);

  console.log(data);
  return data;
};
